<template>
  <div
   class="main_bg"
    style="
      background-image: url('img/topBg.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    "
  >
    <div class="display_flex">
      <back-nav
        class="title_top"
        :icon="'img/backw.png'"
        :textColor="'#fff'"
        :backColor="'none'"
      />
    </div>
    <div class="invite_" style="background-image: url('img/invite.png');" @click="goInvite"></div>
    <div
      class="invite_code"
      style="background-image: url('img/invite_code.png')"
    >
      <div style="font-size: 14px; color: #fff; font-weight: 700">
        {{ indexData.invite_code }}
      </div>
      <button
        class="tag-read index_btn margin-left"
        style="background-image: url('img/index_copy.png')"
        :data-clipboard-text="saveData.introduce_code"
        @click="copy"
      ></button>
    </div>
    <div class="index_code" style="background-image: url('img/index_code.png')">
      <div
        class="invite_left"
        style="
          display: flex;
          flex-direction: column;
          justify-content:center;
          align-items: center;
          background-image: url('img/left_bg.png')
        "
      >
        <div style="flex: 1; text-align: center; margin-top: 10px;display: flex;flex-direction: column;align-items: center;justify-content: center;">
          <div style="font-size: 26px; font-weight: 700; color: #FF9552">
            {{ indexData.total_recharge }}
          </div>
          <div style="font-size: 16px; color: #472417">累计充值</div>
        </div>
        <!-- <div style="flex: 1; text-align: center; margin-top: 10px;display: flex;justify-content: center;">
            <div style="font-size: 16px; color: #FF9552">有效人数</div>
          <div style="font-size: 20px; font-weight: 700; color: #FF9552">
            {{ indexData.effective_invite_num }}
          </div>
        </div> -->
      </div>

      <div
        class="invite_right"
        style="
         display: flex;
          flex-direction: column;
          justify-content:center;
          align-items: center;
          background-image: url('img/right_bg.png')
        "
      >
        <div style="flex: 1; text-align: center; margin-top: 10px;display: flex;flex-direction: column;align-items: center;justify-content: center;">
          <div style="font-size: 26px; font-weight: 700; color: #FF52CB">
            {{ indexData.total_money }}
          </div>
          <div style="font-size: 16px; color: #472417">有效收益</div>
          <div style="font-size: 14px; color: #472417">（下级直充1%）</div>
        </div>
        <!-- <div style="flex: 1; text-align: center; margin: 10px;display: flex;justify-content: center;">
            <div style="font-size: 16px; color: #FF52CB">有效人数</div>
          <div style="font-size: 20px; font-weight: 700; color: #FF52CB">
            {{ indexData.effective_low_invite_num }}
          </div>
        
        </div> -->
      </div>
      <div
        style="background-image: url('img/invite_firend.png')"
        class="invite_btn"
        @click="goSave"
      ></div>
    </div>
    <!-- <div class="invite_number">
      <div class="invite_num" style="background-image: url('img/invite_bg.png')">
        <div class="invite_num_value">{{indexData.invite_num}}</div>
        <div class="invite_num_title">我的邀请</div>
      </div>
      <div class="invite_num" style="background-image: url('img/invite_bg.png')">
        <div class="invite_num_value">{{indexData.effective_invite_num}}</div>
        <div class="invite_num_title">有效人数</div>
      </div>
    </div> -->

    <div
      class="go_invite"
      style="background-image: url('img/go_invite.png')"
      @click="toRecord"
    ></div>
    <div class="top_rule" @click="goRule">
      <img src="img/question.png" alt="" />
    </div>
 
    <!-- <div class="tab_box">
      <div style="background-image: url('img/my_record.png');" class="list_tab">
        <router-link style="width:100%;height: 100%;display: block;" :to="'/myInvite?invite_num=' + indexData.invite_num + '&send_money=' + indexData.total_send_money+ '&effective_num=' + indexData.total_recharge"></router-link>
      </div>
      <div style="background-image: url(img/my_money.png);" class="money_tab">
        <router-link style="width:100%;height: 100%;display: block;" :to="'/withDraw?current_Money=' + indexData.current_money"></router-link>
      </div>
    </div> -->

    <wechat-share @childFn="parentFn" @saveData="getSaveData" />
  </div>
</template>

<script>
import Clipboard from "clipboard";
import "@/assets/css/base.css";
import "@/assets/css/index.css";
import { inviteInfo } from "@/api/api";
import WechatShare from "@/components/wechatShare.vue";
import BackNav from "@/components/backNav.vue";
export default {
  name: "index",
  components: {
    WechatShare,
    BackNav,
  },
  data() {
    return {
      indexData: {},
      beforeUrl: "",
      img: "",
      saveData: {},
    };
  },
  created() {
    let access_token = this.$route.query.access_token;
    localStorage.setItem("access_token", access_token);
    this.fetchData();
  },
  methods: {
    fetchData() {
      inviteInfo()
        .then(
          (response) => {
            this.indexData = response.data;
            console.log(this.indexData);
          },
          (error) => {
            this.$toast.fail(error);
          }
        )
        .catch((error) => {
          this.$toast.fail(error);
        });
    },
    closePage() {
      let params = "调用";
      this.$bridge.callhandler("closePage", params, (data) => {
        // 处理返回数据
      });
    },
    parentFn(url) {
      this.img = url;
    },
    getSaveData(data) {
      this.saveData = data;
    },
    goSave() {
      if (JSON.stringify(this.saveData) == "{}") {
        return false;
      }
      var img = this.img;
      let str = {
        url: img,
      };
      let param = JSON.stringify(str);
      this.$bridge.callhandler("doShareTask", param, (data) => {
        // 处理返回数据
      });
    },
    goRule() {
      this.$router.push({ path: "/rule" });
    },
    goInvite() {
      console.log("点击了");
      this.$router.push({
        path: "/invite?access_token=" + this.$route.query.access_token,
      });
    },
    toRecord() {
      this.$router.push({
        path:
          "/myInvite?access_token=" +
          this.$route.query.access_token +
          "&indexData=" +
          JSON.stringify(this.indexData),
      });
    },
    copy() {
      var clipboard = new Clipboard(".tag-read");
      clipboard.on("success", (e) => {
        this.$toast("已复制到粘贴板");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        Toast("该浏览器不支持自动复制,请手动输入");
        // 释放内存
        clipboard.destroy();
      });
    },
  },
  watch: {
    $route: "fetchData",
  },
};
</script>
